import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AgentTeamCheckResponse, AgentTeamImportResponse } from '../models/agent-team.model';

/** Upload of an AI team file (NEX-1986); the file stays untyped, the server validates it. */
@Injectable({ providedIn: 'root' })
export class AgentTeamService {
  private readonly http = inject(HttpClient);

  check(customerId: string, teamFile: unknown, tokensErneuern = false): Observable<AgentTeamCheckResponse> {
    return this.http.post<AgentTeamCheckResponse>(`${this.teamsUrl(customerId)}/check`, teamFile, {
      params: this.params(tokensErneuern),
    });
  }

  importTeams(customerId: string, teamFile: unknown, tokensErneuern = false): Observable<AgentTeamImportResponse> {
    return this.http.post<AgentTeamImportResponse>(this.teamsUrl(customerId), teamFile, {
      params: this.params(tokensErneuern),
    });
  }

  private params(tokensErneuern: boolean): HttpParams {
    return new HttpParams().set('tokensErneuern', String(tokensErneuern));
  }

  private teamsUrl(customerId: string): string {
    return `${environment.apiBaseUrl}/api/v1/customers/${customerId}/agent-teams`;
  }
}
